import { formatFiltersV2MetaToApiFormat } from "PFApp/components/filters_v2";
import { FiltersV2Data } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import { areFiltersPristine, areFilterValuesEmpty } from "PFCore/helpers/filters";
import { FiltersV2, FilterV2WithValueOnly } from "PFTypes/filters_v2";

export type GenerateApiFiltersOptions = Partial<{
  sendDefaultsAsUndefined: boolean;
  sendEmptyAsUndefined: boolean;
}>;

export const generateApiFilters = (
  {
    childrenFilters,
    mainFilters,
    areChildrenOn
  }: Partial<FiltersV2Data<FilterV2WithValueOnly> | FiltersV2Data>,
  { sendDefaultsAsUndefined = true, sendEmptyAsUndefined = true }: GenerateApiFiltersOptions = {}
) => {
  const areFiltersSameAsDefaults =
    mainFilters &&
    areFiltersPristine(mainFilters as FiltersV2) &&
    (!areChildrenOn || !childrenFilters || areFilterValuesEmpty(childrenFilters));

  if (areFiltersSameAsDefaults && sendDefaultsAsUndefined) {
    return undefined;
  }

  return (
    formatFiltersV2MetaToApiFormat({
      mainFilters,
      childrenFilters: areChildrenOn ? childrenFilters : undefined
    }) || (sendEmptyAsUndefined ? undefined : {})
  );
};
